import { Box, TextField, Button, useTheme, InputAdornment, Grid } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { alpha } from '@mui/material/styles';
import Card from './Card';

const Library = () => {
    const theme = useTheme();

    return (
        <Box
            component="main"
            sx={{
                py: 2,
                width: { xs: 1, sm: 3 / 4, md: 5 / 6 },
                px: { xs: 2, sm: 0, md: 3, lg: 4 },
                m: 'auto',
                mt: 4,
                mb: 4,
            }}
        >
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={9}>
                    <TextField
                        fullWidth
                        label="Search Cards"
                        variant="outlined"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: alpha(theme.palette.primary.main, 0.5),
                                },
                                '&:hover fieldset': {
                                    borderColor: theme.palette.primary.main,
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: theme.palette.secondary.main,
                                },
                                fontFamily: 'Lora',
                            },
                            '& .MuiInputLabel-root': {
                                color: alpha(theme.palette.text.primary, 0.7),
                                fontFamily: 'Lora',
                            },
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: alpha(theme.palette.primary.main, 0.7) }} />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{ fontFamily: 'Cinzel' }}
                    >
                        Filter
                    </Button>
                </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: 2 }} justifyContent="center">
                {Array.from(Array(12).keys()).map((item) => (
                    <Grid
                        item
                        xs={6}
                        sm={6}
                        md={4}
                        lg={3}
                        key={item}
                        sx={{ display: 'flex', justifyContent: 'center' }}
                    >
                        <Card item={item} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Library;